(() => {
  'use strict';
  const initialized = new WeakSet();

  const applySelectedPiecesLabels = (scope = document) => {
    const isHebrew = document.documentElement.lang?.toLowerCase().startsWith('he');
    const label = isHebrew ? 'תכשיטים נבחרים' : 'SELECTED PIECES';
    scope.querySelectorAll('a[href]').forEach((anchor) => {
      let pathname = '';
      try {
        pathname = new URL(anchor.href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (_) {
        return;
      }
      const normalized = pathname.replace(/^\/he(?=\/)/, '');
      if (normalized !== '/collections/sale') return;
      const inNavigation = anchor.closest('.site-nav, .mobile-nav, #NavDrawer, header');
      if (!inNavigation) return;
      const textNodes = Array.from(anchor.childNodes).filter(
        (node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()
      );
      if (textNodes.length) {
        textNodes.forEach((node, index) => {
          node.nodeValue = index === 0 ? label : '';
        });
      } else {
        const textTarget = anchor.querySelector('.site-nav__label, .mobile-nav__faux-link');
        if (textTarget) textTarget.textContent = label;
      }
      anchor.setAttribute('aria-label', label);
    });
  };

  const initialize = (scope = document) => {
    const roots = [];
    if (scope.matches?.('[data-section-type="product"]')) roots.push(scope);
    scope.querySelectorAll('[data-section-type="product"]').forEach((root) => roots.push(root));
    roots.forEach((root) => {
      if (initialized.has(root) || !root.querySelector('[data-leshems-sale-variant], [data-leshems-sale-availability]')) return;
      root.addEventListener('variantChange', (event) => {
        const variant = event.detail?.variant;
        const discounted = variant && variant.compare_at_price > variant.price;
        root.querySelectorAll('[data-leshems-sale-variant]').forEach((terms) => {
          terms.hidden = !discounted;
          const pickup = terms.querySelector('[data-leshems-sale-pickup]');
          if (pickup) pickup.hidden = !variant || variant.available !== true;
        });
        root.querySelectorAll('[data-leshems-sale-availability]').forEach((availability) => {
          const label = variant?.available === true
            ? availability.getAttribute('data-in-stock-label')
            : availability.getAttribute('data-sold-out-label');
          if (label && availability.textContent !== label) availability.textContent = label;
        });
        root.querySelectorAll('[data-leshems-sale-pickup-row]').forEach((row) => {
          row.hidden = !variant || variant.available !== true;
        });
      });
      initialized.add(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applySelectedPiecesLabels();
      initialize();
    });
  } else {
    applySelectedPiecesLabels();
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => {
    applySelectedPiecesLabels(event.target);
    initialize(event.target);
  });
  document.addEventListener('quickview:loaded', () => initialize());
})();
